export interface AccessCodeModalTriggerInput {
  hasInstructions?: boolean | null
  instructionEditsAllowed?: boolean | null
  hasCode: boolean
  /** cwa_access_code_no_code_trigger feature gate value (CBP-3873) */
  noCodeTriggerEnabled?: boolean
}

/**
 * Returns true when the access code / instructions modal should auto-open for
 * the given order.
 *
 * - Gate off (baseline): open when no instructions yet
 *   (`!hasInstructions && instructionEditsAllowed`).
 * - Gate on (CBP-3873): broaden to open when no access code
 *   (`!hasCode && instructionEditsAllowed`).
 */
export function shouldAutoOpenAccessCodeModal(input: AccessCodeModalTriggerInput): boolean {
  const { hasInstructions, instructionEditsAllowed, hasCode, noCodeTriggerEnabled } = input

  if (!instructionEditsAllowed) return false

  return noCodeTriggerEnabled ? !hasCode : !hasInstructions
}
